// extracted by mini-css-extract-plugin
export var divider = "_qt-0";
export var systemMessage = "_qt-1";
export var systemMessageWrapper = "_qt-2";